import {
  getCurrentPathBinding as _getCurrentPathBinding,
  getPathBindings as _getPathBindings,
  PATH_BINDING_GROUPS as _PATH_BINDING_GROUPS,
  replaceCvpageParameterWithPathBinding as _replaceCvpageParameterWithPathBinding,
} from "../../public/pathBinding";
import { CvpSettings } from "./CvpSettings";

export function getPathBindings(
  settings: CvpSettings,
  isEmbedDemo: boolean
): {
  [pKey: string]: PathBindingGroup;
} {
  return _getPathBindings(settings, isEmbedDemo);
}

export function replaceCvpageParameterWithPathBinding(
  settings: CvpSettings,
  url: string,
  isEmbedDemo: boolean
): {
  url: string;
  didReplace: boolean;
  cvpage: string;
  pathBindingGroupKey: string;
} {
  return _replaceCvpageParameterWithPathBinding(settings, url, isEmbedDemo);
}

export const PATH_BINDING_GROUPS: { [key: string]: PathBindingGroup } =
  _PATH_BINDING_GROUPS;

export interface PathBindingGroup {
  key: string;
  pages: string | string[];
  example: string;
  fallback?: boolean;
  value?: string | null;
}

export function getCurrentPathBinding(
  hostUrl: string,
  settings: CvpSettings,
  isEmbedDemo: boolean
): PathBindingGroup | null {
  return _getCurrentPathBinding(hostUrl, settings, isEmbedDemo);
}
